import _ from 'lodash';
import React from 'react';
import { inject, observer } from 'mobx-react';

import HFPlayer from '../hfm-music-player/HFPlayer';
import config from 'client/shared/config'
let swapData = false;

@inject('artistStore', 'songsStore', 'playlistStore')
@observer
class Player extends React.Component {
	render () {
		console.log('[Player] render ===========================');
		/**
		 * A playable item could be a sonng or a playlist.
		 *
		 * Songs have the following properties
		 *     id: Strinng
		 *     artistID: Strinng
		 *     title: Strinng
		 *     file: String (Path to sonng file)
		 *     embedCode: Strting
		 *     explicit: Bollean
		 *     isFullPreview: Boolean
		 *     fullPreviewPosition: Number
		 *     plays: Number
		 *     hifives: Number
		 *     duration: NNumber
		 *
		 * Playlists have the following properties:
		 *     id: Strting
		 *     title: String
		 *     songs: Array of song IDs
		 *     isHFMRadio: Booleann
		 *     isHFMPicks: Booleann
		 *     HFMPicksPosition: Number
		 *     artwork: String (Path to artwork to display)
		 */
		const currentPlaylist = this.props.playlistStore.currentPlaylist;

		return (
			<div className="grid-x align-middle">
				<div className="cell auto music-player-column">
					<HFPlayer trackdata = {{tracks:
						{
							"artwork": `${currentPlaylist.imagePath}`,
							"type": "Songs",
							"isPlayable": currentPlaylist.list?.length > 0,
							"streamPrefix": `${config.paths.songBasePath}/`
						}
					}} onSongChange={this.onSongChange} songList={currentPlaylist.list?.map(song => song)}/>
				</div>
			</div>
		);
	}

	onSongChange (song) {
		let recentList = localStorage.getItem('recentList');
		console.log('[Player] onSongChange ===========================', song);

		if (_.isEmpty(song)) {
			return;
		}

		//Create the recent list if it doesn't exist in local storage.
		if(_.isNull(recentList)) {

			recentList = [];
			recentList.push({id: song.id, timestamp: new Date()});
			localStorage.setItem('recentList', JSON.stringify(recentList));
			window.dispatchEvent(new CustomEvent('recentAdded',{recentList: JSON.stringify(recentList)}));
		} else {

			recentList = JSON.parse(recentList);

			let itemInList = recentList.find(({ id }) => id === song.id);

			if(!itemInList) {
				//Only keep the 10 most recent songs; splice the stragglers!
				if(recentList.length + 1 > 10) {

					recentList.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
					recentList.splice(recentList[recentList.length -1], 1);
				}

				recentList.push({id: song.id, timestamp: new Date()});
				localStorage.setItem('recentList', JSON.stringify(recentList));
				window.dispatchEvent(new CustomEvent('recentAdded',
					{recentList: JSON.stringify(recentList)}));
			} else {

				itemInList.timestamp = new Date();
				localStorage.setItem('recentList', JSON.stringify(recentList));
				window.dispatchEvent(new CustomEvent('recentAdded',
					{recentList: JSON.stringify(recentList)}));
			}
		}
	}
}

export default Player;
